const o=(o,t,c)=>t-o==0?1:(c-o)/(t-o);export{o as progress};
